import http from './http';

const routerPrefix = '/metrics';

export function getViewerSessionsTimeseriesDataApi(reqBody, options = {}) {
  return http.post(`${routerPrefix}/timeseries`, reqBody, options);
}

export function getViewerSessionsDistributionDataApi(reqBody, options = {}) {
  return http.post(`${routerPrefix}/distribution`, reqBody, options);
}

export function getViewerSessionsScanDataApi(reqBody, options = {}) {
  return http.post(`${routerPrefix}/scan`, reqBody, options);
}

export const getTimelineData = (body, options = {}) => http.post(`${routerPrefix}/timeline`, { ...body }, options);
